import { render, staticRenderFns } from "./TabExecuted.vue?vue&type=template&id=b2b24f86&"
import script from "./TabExecuted.vue?vue&type=script&lang=js&"
export * from "./TabExecuted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports